import qs from 'qs';

// eslint-disable-next-line import/prefer-default-export
export function generatePopUpLink(location, hashName, hashParams = {}) {
  let toLink = `${location.pathname}${location.search}#pop-up/${hashName}`;
  if (Object.keys(hashParams).length > 0) {
    toLink += `?${qs.stringify(hashParams)}`;
  }
  return toLink;
}



// WEBPACK FOOTER //
// ./src/components/Common/GlobalPopUps/utils.js